import { Eye, Edit2, Trash2 } from 'lucide-react';
import { getAssetUrl } from '../../../../../../utils/assetUtils';

const PackageCard = ({
    pkg,
    onView,
    onEdit,
    onDelete,
    isGhost = false
}) => {
    if (isGhost) {
        return (
            <div className="bg-white border border-slate-200 rounded-2xl overflow-hidden shadow-xs flex flex-col group">
                <div className="h-36 relative overflow-hidden p-4 text-white flex flex-col justify-between bg-slate-800">
                    <img
                        src={pkg.image}
                        alt={pkg.title}
                        className="absolute inset-0 w-full h-full object-cover"
                    />
                    <div className={`absolute inset-0 bg-gradient-to-t ${pkg.gradient || 'from-black/80 via-black/30 to-black/40'}`} />
                    <div className="flex items-center justify-between relative z-10">
                        <span className="text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full bg-black/40 backdrop-blur-md text-white border border-white/20">
                            {pkg.region}
                        </span>
                        <span className="text-[11px] font-medium text-white drop-shadow-sm">{pkg.destination_tag}</span>
                    </div>
                    <span className="font-bold text-sm line-clamp-1 relative z-10 text-white drop-shadow-sm">{pkg.title}</span>
                </div>

                <div className="p-4 flex-1 flex flex-col justify-between space-y-3">
                    <div>
                        <h3 className="font-bold text-slate-800 text-sm line-clamp-1">{pkg.title}</h3>
                        <p className="text-xs text-slate-500 line-clamp-2 mt-1">{pkg.description}</p>
                    </div>

                    <div className="flex items-center gap-2 border-t border-slate-100 pt-3">
                        <div className="flex-1 py-2 px-3 bg-slate-50 text-slate-600 text-xs font-medium rounded-xl border border-slate-200 flex items-center justify-center gap-1.5">
                            <Eye size={13} className="text-slate-400" />
                            View Package
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="group bg-white border border-slate-200 hover:border-[#067978]/30 rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-300 flex flex-col">
            <div className="h-36 bg-slate-100 relative overflow-hidden flex items-center justify-center">
                <div className="w-full h-full bg-gradient-to-br from-[#067978] to-teal-700 p-4 text-white flex flex-col justify-end transition-transform duration-500 group-hover:scale-105 absolute inset-0">
                    <span className="text-xs font-bold uppercase tracking-wider text-teal-200">{pkg.destination_tag || pkg.region}</span>
                    <span className="font-bold text-base truncate">{pkg.title}</span>
                </div>
                {pkg.cover_image_url && (
                    <img 
                        src={getAssetUrl(pkg.cover_image_url)} 
                        alt={pkg.title} 
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 absolute inset-0 z-10"
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.style.display = 'none';
                        }}
                    />
                )}
            </div>

            <div className="p-4 flex-1 flex flex-col justify-between space-y-3">
                <div>
                    <h3 className="font-bold text-slate-800 text-base line-clamp-1">{pkg.title}</h3>
                    <p className="text-xs text-slate-500 line-clamp-2 mt-1">{pkg.description}</p>
                    <div className="flex items-center gap-2 mt-3 text-xs text-slate-400 font-medium">
                        <span className="capitalize px-2 py-0.5 bg-slate-100 rounded text-slate-600 font-semibold">{pkg.region}</span>
                        {pkg.destination_tag && <span>• {pkg.destination_tag}</span>}
                    </div>
                </div>

                <div className="flex items-center gap-2 border-t border-slate-100 pt-3">
                    <button
                        type="button"
                        onClick={() => onView(pkg)}
                        className="flex-1 flex items-center justify-center gap-1.5 py-2 px-3 bg-slate-50 hover:bg-slate-100 text-slate-700 text-xs font-bold rounded-xl border border-slate-200 transition-colors cursor-pointer"
                    >
                        <Eye size={14} className="text-slate-500" />
                        View Package
                    </button>
                    
                    <button
                        type="button"
                        onClick={() => onEdit(pkg)}
                        className="p-2 bg-white hover:bg-slate-50 text-slate-600 hover:text-[#067978] border border-slate-200 rounded-xl transition-colors cursor-pointer"
                        title="Edit Package"
                    >
                        <Edit2 size={15} />
                    </button>
                    
                    <button
                        type="button"
                        onClick={() => onDelete(pkg._id)}
                        className="p-2 bg-white hover:bg-rose-50 text-rose-600 hover:text-rose-700 border border-slate-200 hover:border-rose-200 rounded-xl transition-colors cursor-pointer"
                        title="Delete Package"
                    >
                        <Trash2 size={15} />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PackageCard;
